import { firebase } from './api/firebase'
import { firebaseAction } from 'vuexfire'
const _ = require('lodash')
const db = firebase.database()
const environment = require('@/environments/production')

export const inventoryCounts = {
  state: {
    counts: {}
  },
  getters: {
    getInventoryCount: state => {
      return (state.counts.inventoryCounts) ? state.counts.inventoryCounts.totalCount : 0
    },
    getPendingCount: state => {
      return (state.counts.pendingCounts) ? state.counts.pendingCounts.totalCount : 0
    },
    getQueueCount: state => {
      return (state.counts.queueCounts) ? state.counts.queueCounts.totalCount : 0
    },
    getAllInventoryCounts: (state, getters) => {
      let counts = {}
      if (state.counts.inventoryCounts) {
        let data = state.counts.inventoryCounts
        let skipKeys = ['collectionTotalCount', 'totalCounts']
        // we'll get a list of collections in this users inventory.
        let collections = Object.keys(data)
        collections.forEach(collection => {
          let styles = Object.keys(data[collection])
          styles.forEach(style => {
            if (!skipKeys.includes(style)) {
              counts[style] = counts[style] || {}

              let sizes = Object.keys(data[collection][style])
              sizes.forEach(size => {
                // size = size.replace('-', '/')
                console.log('getAllInventoryCounts (size): ', size)
                counts[style][size] = (counts[style][size]) ? counts[style][size] + data[collection][style][size] : data[collection][style][size]
                console.log('counts: ', counts[style][size])
              })
            }
          })
        })
      }
      // console.log(counts)
      return counts
    },
    getChartData: (state, getters) => {
      // we're only pulling counts for in inventory data, queue and pending numbers are not included.
      const data = {
        series: [
          {
            name: 'Styles',
            // data: [{name: 'Amelia', y: 53, drilldown: 'Amelia'}, {name: 'Azure', y: 74, drilldown: 'Azure'}, {name: 'Carly', y: 162, drilldown: 'Carly'}, {name: 'Classic', y: 82, drilldown: 'Classic'}, {name: 'Irma', y: 190, drilldown: 'Irma'}, {name: 'Joy', y: 53, drilldown: 'Joy'}, {name: 'Leggings', y: 424, drilldown: 'Leggings'}, {name: 'Lindsay', y: 24, drilldown: 'Lindsay'}, {name: 'Lola', y: 42, drilldown: 'Lola'}, {name: 'Lynnae', y: 6, drilldown: 'Lynnae'}, {name: 'Mark', y: 21, drilldown: 'Mark'}, {name: 'Maxi', y: 64, drilldown: 'Maxi'}, {name: 'Nicole', y: 43, drilldown: 'Nicole'}, {name: 'Perfect', y: 132, drilldown: 'Perfect'}, {name: 'Randy', y: 75, drilldown: 'Randy'}, {name: 'Sariah', y: 29, drilldown: 'Sariah'}],
            data: _.map(getters.getAllInventoryCounts, (v, k, col) => {
              return {
                name: k,
                y: v.totalCount,
                drilldown: k
              }
            }),
            colorByPoint: true
          }
        ],
        drilldown: {
          name: 'Style Counts',
          // series: [{name: 'Amelia', id: 'Amelia', y: 53, data: [['2x', 7], ['3x', 5], ['l', 11], ['m', 7], ['s', 9], ['xl', 8], ['xs', 5], ['xxs', 2]]}, {name: 'Azure', id: 'Azure', y: 74, data: [['2x', 6], ['3x', 4], ['l', 8], ['m', 6], ['s', 11], ['xl', 8], ['xs', 31]]}, {name: 'Carly', id: 'Carly', y: 162, data: [['2x', 15], ['3x', 19], ['l', 27], ['m', 23], ['s', 22], ['xl', 25], ['xs', 16], ['xxs', 15]]}, {name: 'Classic', id: 'Classic', y: 82, data: [['2x', 10], ['3x', 9], ['l', 10], ['m', 9], ['s', 12], ['xl', 13], ['xs', 10], ['xxs', 9]]}, {name: 'Irma', id: 'Irma', y: 190, data: [['2x', 21], ['3x', 21], ['l', 38], ['m', 20], ['s', 21], ['xl', 26], ['xs', 23], ['xxs', 20]]}, {name: 'Joy', id: 'Joy', y: 53, data: [['l', 12], ['m', 11], ['s', 10], ['xl', 12], ['xs', 8]]}, {name: 'Leggings', id: 'Leggings', y: 424, data: [['lxl', 30], ['os', 177], ['sm', 40], ['tc', 145], ['tw', 32]]}, {name: 'Lindsay', id: 'Lindsay', y: 24, data: [['l', 10], ['m', 8], ['s', 6]]}, {name: 'Lola', id: 'Lola', y: 42, data: [['2x', 6], ['l', 6], ['m', 8], ['s', 8], ['xl', 6], ['xs', 5], ['xxs', 3]]}, {name: 'Lynnae', id: 'Lynnae', y: 6, data: [['l', 2], ['m', 1], ['s', 2], ['xl', 1]]}, {name: 'Mark', id: 'Mark', y: 21, data: [['2x', 7], ['3x', 2], ['l', 3], ['m', 5], ['xl', 4]]}, {name: 'Maxi', id: 'Maxi', y: 64, data: [['2x', 7], ['3x', 7], ['l', 9], ['m', 8], ['s', 9], ['xl', 8], ['xs', 13], ['xxs', 3]]}, {name: 'Nicole', id: 'Nicole', y: 43, data: [['2x', 7], ['3x', 5], ['l', 6], ['m', 5], ['s', 8], ['xl', 5], ['xs', 4], ['xxs', 3]]}, {name: 'Perfect', id: 'Perfect', y: 132, data: [['2x', 14], ['3x', 14], ['l', 21], ['m', 22], ['s', 17], ['xl', 24], ['xs', 13], ['xxs', 7]]}, {name: 'Randy', id: 'Randy', y: 75, data: [['2x', 9], ['3x', 10], ['l', 7], ['m', 12], ['s', 9], ['xl', 8], ['xs', 12], ['xxs', 8]]}, {name: 'Sariah', id: 'Sariah', y: 36, data: [['6', 2], ['8', 3], ['12', 1], ['l', 7], ['m', 8], ['s', 6], ['xl', 9]]}],
          series: _.map(getters.getAllInventoryCounts, (v, k, col) => {
            return {
              name: k,
              id: k,
              y: v.totalCount,
              data: _.filter(
                _.map(v, (value, key) => {
                  if (key !== 'totalCount') {
                    return [key, value]
                  }
                }),
                o => {
                  if (o) {
                    return o
                  }
                }
              )
            }
          })
        }
      }
      // data.series.data = _.map(state.counts.pendingCount, mapSeries)
      // console.log(data)
      return data
    }

  },
  mutations: {
    setCounts: (state, payload) => {
      state.counts = payload
    }
    // detachCounts: (state, payload) => {
    //   // state.detachCounts = payload
    //   state.detachCounts = null
    // }
  },
  actions: {
    setCollection: firebaseAction((context, payload) => {
      let ref = db.ref(environment.schema.inventoryCounts).child(context.rootState.user.groupId)
      context.bindFirebaseRef('counts', ref)
    })
    // setCollection: (context, groupId) => {
    //   // make our call to the API to get detach fn and inventory data returned
    //   return api.getInventoryOnce(groupId)
    //     .then(countData => {
    //       console.log(JSON.stringify(countData))
    //       context.commit('setCounts', countData)
    //     })

    //   // TODO: need to setup the API such that we can support realtime updates
    //   // let unsubscribe = db.collection('inventory')
    //   //   .doc(`${context.rootGetters.getGroupId}`)
    //   //   .onSnapshot(doc => {
    //   //     console.log('setting counts data...')
    //   //     context.commit('setCounts', doc.data())
    //   //   })
    //   // context.commit('detachCounts', unsubscribe)
    // }
    // detachCounts: (context) => {
    //   // Since we don't have realtime data updates nothing to do here.
    //   context.state.detachCounts()
    // }
  }
}



// WEBPACK FOOTER //
// ./src/store/counts.js